import type { TalentCandidateOrigin } from "@/api/schedule/models";

export const scheduleTimeOptions = Array.from({ length: 23 }, (_, index) => {
  const totalMinutes = 8 * 60 + index * 30;
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  const value = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;

  return { label: minutes === 0 ? `${hours}h` : `${hours}h30`, value };
});

export type VisualTalentOrigin = "WALK_IN" | "SCOUTER" | "WEB_SCOUTER" | "WEBSITE";

export const talentOriginOptions = [
  { label: "Entrada espontânea (walk-in)", value: "WALK_IN" },
  { label: "Scouter", value: "SCOUTER" },
  { label: "Web Scouter", value: "WEB_SCOUTER" },
  { label: "Site ou landing page", value: "WEBSITE" },
];

export const candidateOriginLabels: Record<TalentCandidateOrigin, string> = {
  SPONTANEOUS_ENTRY: "Entrada espontânea (walk-in)",
  SCOUTER: "Scouter",
  WEB_SCOUTER: "Web Scouter",
  SITE_OR_LANDING_PAGE: "Site ou landing page",
};

const originMap: Record<VisualTalentOrigin, TalentCandidateOrigin> = {
  WALK_IN: "SPONTANEOUS_ENTRY",
  SCOUTER: "SCOUTER",
  WEB_SCOUTER: "WEB_SCOUTER",
  WEBSITE: "SITE_OR_LANDING_PAGE",
};

export function mapTalentOrigin(origin: VisualTalentOrigin): TalentCandidateOrigin {
  return originMap[origin];
}
